import { EnumSchema } from '../metadata-schema';

export const DoorstroomExt: EnumSchema = {
	"type": "string",
	"title": "DoorstroomExt",
	"enum": [
		"Doorstroom",
		"Opstroom",
		"Doublure",
		"Afgewezen",
		"Afstroom",
		"Geslaagd",
		"Doorstroom (extern)",
		"Opstroom (extern)",
		"Doublure (extern)",
		"Afgewezen (extern)",
		"Afstroom (extern)",
		"Instroom"
	]
};
